import { IProductChildMinimizedData } from "@/app/components/pages-components/product-details-page/details-belpers/product-attributes/helpers/interfaces";
import {
  ConfigTypes,
  BuilderTypes,
  Size,
  TitleAlign,
} from "../../../common-interfaces/api-enums";
import { IEventCustomData } from "../IEvent";
import { IBrand } from "./IBrands";
import { Config_Customize } from "./ICategory";
import { IFilter } from "../../filters/interfaces/IGetFilters";
export enum ProductStyleTypes {
  small = "small",
  large = "large",
}
export enum DiscountTypes {
  rate = "rate",
  fixed = "fixed",
}
export interface IProduct {
  brand?: IBrand;
  description: string;
  discount?: number;
  discount_amount: number;
  discount_type?: DiscountTypes;
  has_discount: boolean;
  has_required_addons: boolean;
  id: number;
  image_url: string;
  is_configurable: boolean;
  is_favorite: boolean;
  is_new: boolean;
  max_quantity_in_cart: number | null;
  min_quantity_in_cart: number | null;
  name: string;
  price: number;
  price_without_discount: number;
  quantity_on_hand: number;
  rate: number;
  sharable_text: string;
  slug: string;
  parent_id: null | number;
  preview_type: string;
  sku: string;
  thumbnail_url: string;
  unit_id: string;
  units: [];
  has_required_fields: boolean;
  has_term_and_condition: boolean;
  has_configurable_parent: boolean;
  selling_prices: ISelling_Prices[];
  images: {
    image_url: string;
    thumbnail_url: string;
    type: "image" | "video";
  }[];
  ratings: Ratings;
  can_review: boolean;
  custom_data?: IEventCustomData;
  categories_names?: string[];

  children: IProductChildMinimizedData[];
  attribute_ids: number[];
  attributes_builder: IFilter[];
  type: string | "bundle";
}
export interface IProducts {
  index?: number;
  type?: BuilderTypes.product;
  configurations?: {
    customize?: Config_Customize;
    style_type?: Size; // ProductStyleTypes;
    target_url?: string;
    title?: string;
    title_align?: TitleAlign;
    type?: ConfigTypes;
    view_all?: boolean;
  };
  data: IProduct[];
}

export interface ISelling_Prices {
  price: number;
  price_without_discount: number;
  quantity: number;
  // 0 = equal  , 1 = bigger than
  quantity_rule: 0 | 1;
  unit_id?: number;
  unit_name?: string;
  currency_code?: string;
}

export type Ratings = {
  one_star: number;
  two_stars: number;
  three_stars: number;
  four_stars: number;
  five_stars: number;
};
